import React from 'react';
import { Route } from 'react-router-dom';

import { ExtendedRouteProps } from 'app/lib/routing/types';

import { PrivateRoute } from 'app/lib/routing/components/PrivateRoute';

export const RouteWithSubRoutes: React.FC<ExtendedRouteProps> = ({
  exact,
  path,
  private: privateRoute,
  component: Component,
  routes,
}) => {
  if (privateRoute) {
    return (
      <PrivateRoute
        exact={exact}
        path={path}
        component={Component} />
    );
  }

  return (
    <Route
      exact={exact}
      path={path}
      render={(props): React.ReactNode => (
        <Component
          {...props}
          routes={routes} />
      )} />
  );
};
